import {
  Dispatch,
  HTMLAttributes,
  MutableRefObject,
  ReactNode,
  SetStateAction,
  useCallback,
} from "react";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";

import { DropdownArrow } from "@Console/assets/DropdownArrow";

import {
  ConsolePageDropDownContainer,
  ConsolePageDropDownContent,
  ConsolePageDropDownTriggerElementContainer,
} from "./styles";

interface IConsolePageDropDownProps extends HTMLAttributes<HTMLDivElement> {
  triggerElement: ReactNode;
  shouldReverse?: boolean;
  triggerRef?: MutableRefObject<HTMLDivElement>;
  setIsDropdownOpen: Dispatch<SetStateAction<boolean>>;
  isDropdownOpen: boolean;
}

const ConsolePageDropDown = ({
  shouldReverse,
  triggerRef,
  isDropdownOpen,
  setIsDropdownOpen,
  ...props
}: IConsolePageDropDownProps) => {
  const openDropdown = useCallback(
    () => setIsDropdownOpen(true),
    [setIsDropdownOpen],
  );

  const closeDropdown = useCallback(
    () => setIsDropdownOpen(false),
    [setIsDropdownOpen],
  );

  const handleToggleDropdown = useCallback(() => {
    isDropdownOpen ? closeDropdown() : openDropdown();
  }, [closeDropdown, isDropdownOpen, openDropdown]);

  return (
    <ConsolePageDropDownContainer
      show={isDropdownOpen}
      shouldReverse={shouldReverse}
      {...props}
    >
      <ComponentErrorBoundary>
        <ConsolePageDropDownTriggerElementContainer
          ref={triggerRef}
          onClick={handleToggleDropdown}
        >
          {props.triggerElement}

          <DropdownArrow className="console-page-dropdown-arrow" />
        </ConsolePageDropDownTriggerElementContainer>
      </ComponentErrorBoundary>

      <ComponentErrorBoundary>
        <ConsolePageDropDownContent
          show={isDropdownOpen}
          shouldReverse={shouldReverse}
        >
          {props.children}
        </ConsolePageDropDownContent>
      </ComponentErrorBoundary>
    </ConsolePageDropDownContainer>
  );
};

export default ConsolePageDropDown;
